import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Form from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';
import API from 'core/Api';
import setServerErrors from 'utils/helpers/formErrors';
import { createErrorFromResponse } from 'core/Error';
import { useModal } from 'store/modal';

interface IInputs {
  email: string;
  old_password: string;
  password: string;
  password_confirmation: string;
  code?: string;
}

interface IProps {
  title: string;
  email: string;
  request2FaCode: boolean;
}

const ChangePasswordForm: FC<IProps> = ({ title, email, request2FaCode }: IProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const methods = useForm<IInputs>({
    defaultValues: {
      email,
    },
  });
  const { showModal } = useModal();
  const onSubmit = (data: IInputs) => {
    return API.post('auth/password-change', data)
      .then(() => {
        showModal({
          type: 'success',
          content: 'Вашата парола беше променена.',
        });
        return history.push('/logout');
      })
      .catch(err => setServerErrors(createErrorFromResponse(err).errors, methods.setError));
  };
  return (
    <Form
      title={title}
      methods={methods}
      onSubmit={onSubmit}
      btnLabel={t('common.save')}
      isHorizontal
    >
      <FormGroup
        controlId="formGroupEmail"
        label={t('auth.login.email')}
        type="email"
        name="email"
        formGroupClassName="u-visibility--hidden position-absolute"
      />
      <FormGroup
        controlId="formGroupOldPass"
        label={t('profile.currentPass')}
        type="password"
        name="old_password"
        isPassword
        isRequired
        isHorizontal
      />
      <FormGroup
        controlId="formGroupPass"
        label={t('profile.pass')}
        type="password"
        name="password"
        hint={t('profile.passHint')}
        isPassword
        isRequired
        isHorizontal
      />
      <FormGroup
        controlId="formGroupPassConfirm"
        label={t('profile.confirmPass')}
        type="password"
        name="password_confirmation"
        isPassword
        isConfirmPassword
        isRequired
        isHorizontal
      />
      {request2FaCode && (
        <FormGroup
          controlId="formGroupCode"
          label={t('profile.code')}
          placeholder="******"
          type="tel"
          name="code"
          hint={t('profile.codeHint')}
          autoComplete="off"
          isRequired
          isVerificationCode
          isHorizontal
        />
      )}
    </Form>
  );
};

export default ChangePasswordForm;
